module.exports = __webpack_public_path__ + "media/bootstrap-icons/moon-stars-a66c0572.svg";